import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import popupPageModeMixin from '@/mixins/popupPageModeMixin';

export default {
  mixins: [popupPageModeMixin],
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    onCreateAccount() {
      if (this.isPage) {
        this.$router.push({ name: 'account-page-register' });
      } else {
        this.setCurrentPopup(MODALS.REGISTER);
      }
    },
  },
};
